<template>
  <div>
    <Card shadow>
      <Row :gutter="18">
        <Col span="7" style="display:none">
          <label style="display: flex; align-items: center">
            <span style="width: 80px">代理组:</span>
            <Select
              v-model="table.params.platid"
              filterable
              placeholder="筛选 所属分组"
              @on-change="updatePlatId"
            >
              <Option
                v-for="(item, index) in plat_list"
                :value="item.id"
                :label="item.name"
                :key="index"
              >
                {{ item.name }}
                <span style="color: #bbb">({{ item.id }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="4">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">代理:</span>
            <Select
              v-model="table.params.app_id"
              filterable
              placeholder="筛选代理"
            >
              <Option
                v-for="(item, index) in app_list"
                :value="item.appid"
                :label="item.appName"
                :key="index"
              >
                {{ item.appName }}
                <span style="color: #bbb">({{ item.appid }})</span>
              </Option>
            </Select>
          </label>
        </Col>
        <Col span="5" class="antiBrush">
          <label style="display: flex; align-items: center">
            <span style="width: 180px">配置玩家ID:</span>
            <Input
              v-model="table.params.uid"
              placeholder="筛选 配置玩家ID"
              type="number"
            ></Input>
          </label>
        </Col>
        <Col span="6">
          <label style="display: flex; align-items: center">
            <span style="width: 50px">状态:</span>
            <Select
              v-model="table.params.status"
              filterable
              placeholder="筛选 状态"
              clearable
            >
              <Option
                v-for="(item, index) in select.status_list"
                :value="item.value"
                :label="item.name"
                :key="index"
                >{{ item.name }}</Option
              >
            </Select>
          </label>
        </Col>
        <Col span="2">
          <Button type="primary" @click="GetInfiniteUserList(1)">查询</Button>
        </Col>
        <Col span="3">
          <Button type="primary" @click="setModalShow(0)">添加ID</Button>
        </Col>
        <Button
          type="info"
          :size="isMOble() ? 'small' : 'default'"
          @click="Refres"
          style="float: right"
          >同步配置</Button
        >
      </Row>
    </Card>

    <Table
      border
      :columns="table.columns"
      :data="table.data"
      style="margin-top: 12px"
      :max-height="450"
    ></Table>
    <Page
      v-show="table.data.length"
      show-sizer
      show-total
      style="margin-top: 10px"
      :total="table.total"
      :current="table.params.page"
      :page-size-opts="table.pageSizes"
      :page-size="table.params.page_size"
      @on-page-size-change="limitchange"
      @on-change="pagechange"
    ></Page>

    <!-- 更新信息 -->
    <Modal v-model="SetModal.show" width="600" @on-cancel="closeOpen">
      <p slot="header" style="color: #1c2438; text-align: center">
        <span>{{ SetModal.form.params.id ? '修改' : '新增' }}代防刷限制</span>
      </p>
      <div>
        <Form
          :label-width="110"
          :ref="SetModal.form.ref"
          :model="SetModal.form.params"
          :rules="SetModal.form.rules"
        >
          <Row>
            <Col span="20">
              <FormItem label="选择所属分组" prop="platid">
                <Select
                  v-model="SetModal.form.params.platid"
                  filterable
                  placeholder="筛选 分组"
                  :disabled="!!SetModal.form.params.id"
                >
                  <Option
                    v-for="(item, index) in plat_list"
                    :value="item.id"
                    :label="item.name"
                    :key="index"
                  >
                    {{ item.name }}
                    <span style="color: #bbb">({{ item.id }})</span>
                  </Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="20">
              <FormItem label="选择所属盘口" prop="app_id">
                <Select
                  v-model="SetModal.form.params.app_id"
                  filterable
                  placeholder="筛选 盘口"
                  :disabled="!!SetModal.form.params.id"
                >
                  <Option
                    v-for="(item, index) in app_list"
                    :value="item.appid"
                    :label="item.appName"
                    :key="index"
                  >
                    {{ item.appName }}
                    <span style="color: #bbb">({{ item.appid }})</span>
                  </Option>
                </Select>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="20">
              <FormItem prop="uid" label="玩家ID" class="antiBrush">
                <Input
                  v-model="SetModal.form.params.uid"
                  placeholder="填写配置玩家ID"
                  type="number"
                  :disabled="!!SetModal.form.params.id"
                ></Input>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="20">
              <FormItem label="配置状态">
                <Radio-group v-model="SetModal.form.params.status">
                  <Radio :label="1">启用</Radio>
                  <Radio :label="0">禁用</Radio>
                </Radio-group>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="20">
              <FormItem label="配置备注">
                <Input
                  v-model="SetModal.form.params.desc"
                  placeholder="输入备注内容"
                ></Input>
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="closeOpen()">取消</Button>
        <Button type="warning" @click="UpdateInfiniteUser(null)">确定</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {
  GetInfiniteUserList,
  UpdateInfiniteUser,
  RefreshConfig
} from '@/api/admin/risk'
import moment from 'moment'
export default {
  name: 'AntiBrush',
  data() {
    return {
      select: {
        status_list: [
          { value: 1, name: '启用' },
          { value: 0, name: '禁用' }
        ]
      },
      table: {
        params: {
          uid: null,
          platid: 0,
          app_id: 0,
          status: -1,
          page: 1,
          page_size: 10
        },
        data: [],
        columns: [
          { type: 'index', title: '序号', width: 50, align: 'center' },
          {
            key: 'app_id',
            align: 'center',
            minWidth: 120,
            render: (h, params) => {
              let app_info = this.getAppInfo(params.row)
              return h('div', [
                h('span', app_info.appName || ''),
                h(
                  'span',
                  { style: 'color:#bbb;' },
                  app_info.appName ? `（${app_info.appid}）` : ''
                )
              ])
            },
            renderHeader: (h, params) =>
              this.renderHeader(h, '所属盘口', '显示对应玩家所属盘口')
          },
          {
            key: 'uid',
            align: 'center',
            minWidth: 120,
            render: (h, params) => h('span', '无限代防刷'),
            renderHeader: (h, params) =>
              this.renderHeader(h, '限制类型', '显示该条信息配置的限制类型')
          },
          {
            key: 'uid',
            align: 'center',
            minWidth: 120,
            renderHeader: (h, params) =>
              this.renderHeader(h, '限制ID', '显示该条信息配置限制玩家UID')
          },
          {
            key: 'status',
            align: 'center',
            minWidth: 120,
            render: (h, params) =>
              h(
                'span',
                { style: { color: params.row.status ? '#32CD32' : 'red' } },
                params.row.status ? '启用' : '禁用'
              ),
            renderHeader: (h, params) =>
              this.renderHeader(h, '状态', '显示对应配置的状态')
          },
          {
            key: 'ctime',
            align: 'center',
            minWidth: 120,
            render: (h, params) =>
              h(
                'span',
                moment(params.row.ctime * 1000)
                  .locale('zh-cn')
                  .format('YYYY-MM-DD HH:mm:ss')
              ),
            renderHeader: (h, params) =>
              this.renderHeader(h, '创建时间', '显示对应的创建时间')
          },
          {
            key: 'desc',
            align: 'center',
            minWidth: 120,
            renderHeader: (h, params) =>
              this.renderHeader(h, '备注', '显示对应的备注')
          },

          {
            key: '',
            align: 'center',
            title: '管理',
            minWidth: 220,
            fixed: 'right',
            render: (h, params) => {
              return h('div', [
                h(
                  'Button',
                  {
                    props: { type: 'primary' },
                    style: { margin: '2px', padding: '5px 20px' },
                    on: {
                      click: () => {
                        this.setModalShow(1, params.row)
                      }
                    }
                  },
                  '编辑配置'
                ),
                h(
                  'Button',
                  {
                    props: { type: 'error' },
                    style: { margin: '2px', padding: '5px 20px' },
                    on: {
                      click: () => {
                        this.$Modal.confirm({
                          title: '确认删除',
                          content: '确认删除此条记录',
                          onOk: () => {
                            this.updateInfinite({}, params.row.id)
                          }
                        })
                      }
                    }
                  },
                  '删除'
                )
              ])
            }
          }
        ],
        total: 0,
        pageSizes: [10, 20, 30, 40]
      },
      SetModal: {
        show: false,
        form: {
          ref: 'gameriskSet',
          params: {
            id: '',
            uid: null,
            platid: 0,
            app_id: 0,
            status: 1,
            type: 0,
            ctime: 0,
            desc: ''
          },
          rules: {
            uid: [
              {
                required: true,
                trigger: 'blur',
                validator: this.simpleVerify('请输入玩家ID')
              }
            ],
            platid: [
              {
                required: true,
                trigger: 'change',
                validator: this.simpleVerify('请选择分组')
              }
            ],
            app_id: [
              {
                required: true,
                trigger: 'change',
                validator: this.simpleVerify('请选择盘口')
              }
            ]
          }
        }
      }
    }
  },
  methods: {
    getAppList() {
      return this.app_list.filter(el => el.platform == this.table.params.platid)
    },
    updatePlatId() {
      this.table.params.app_id = this.app_list.filter(
        el => el.platform == this.table.params.platid
      )[0].appid
    },
    getAppInfo(item) {
      return this.app_list.find(el => el.appid == item.app_id) || {}
    },
    setModalShow(type, item = {}) {
      this.$refs.gameriskSet.resetFields()
      this.SetModal.show = true
      this.updateModalParams(type, item)
    },
    updateModalParams(type, item) {
      let {
        platid = 0,
        app_id = 0,
        uid = null,
        status = 1,
        ctime,
        desc = '',
        id
      } = item
      this.SetModal.form.params.type = type
      this.SetModal.form.params.platid = platid
      this.SetModal.form.params.app_id = app_id
      this.SetModal.form.params.uid = uid
      this.SetModal.form.params.status = status
      this.SetModal.form.params.ctime = ctime
      this.SetModal.form.params.desc = desc
      this.SetModal.form.params.id = id
    },
    closeOpen() {
      this.$refs.gameriskSet.resetFields()
      this.SetModal.show = false
    },
    //更新信息
    UpdateInfiniteUser() {
      this.$refs.gameriskSet.validate(valid => {
        if (valid) {
          let param = { ...this.SetModal.form.params }
          param.uid = Number(param.uid)
          this.updateInfinite(param)
        } else {
        }
      })
    },
    updateInfinite(param, id) {
      if (id) {
        param.type = 2
        param.id = id
      }
      UpdateInfiniteUser(param).then(res => {
        this.GetInfiniteUserList()
        this.closeOpen()
      })
    },
    //获取列表
    GetInfiniteUserList(num) {
      if (num) {
        this.table.params.page = 1
      }
      let param = { ...this.table.params }
      param.status = !param.status && param.status !== 0 ? -1 : param.status
      if (param.uid) {
        param.uid = Number(param.uid)
      } else {
        param.uid = null
      }
      GetInfiniteUserList(param).then(res => {
        this.table.data = res._param.list || []
        this.table.total = res._param.total
      })
    },
    limitchange(limit) {
      this.table.params.page = 1
      this.table.params.page_size = limit
      this.GetInfiniteUserList()
    },
    pagechange(page) {
      this.table.params.page = page
      this.GetInfiniteUserList()
    },

    Refres() {
      let param = { is_all: 1, refresh_cfg: [7] }
      RefreshConfig(param).then(res => {
        this.$Notice.success({
          title: '操作提示',
          desc: '成功刷新配置'
        })
      })
    },
    initFunc() {
      let platid = this.getinitPlatId()
      this.table.params.platid = platid
      let app = this.app_list.find(el => el.platform == platid)
      this.table.params.app_id = app ? app.appid : 0
      this.GetInfiniteUserList()
    }
  },

  created() {
    this.initFunc()
  }
}
</script>
<style lang="less" scoped>
.btn_batch {
  margin-right: 12px;
}
</style>
